export default "__VITE_ASSET__BgIdkWOh__"